import React from 'react';
import Dashboard from '../components/MotivationAdoption/Dashboard';

class MotivationAdoptionContainer extends React.Component {
  constructor(props) {
    super(props);
    const today = new Date().toISOString().slice(0, 10);
    const thirtyDaysAgo = new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
    this.state = {
      kpis: null,
      breakdown: null,
      table: { rows: [], total: 0, page: 1, perPage: 25 },
      goalStatus: { adoption: null },
      filters: {
        startDate: props.startDate || thirtyDaysAgo,
        endDate: props.endDate || today,
        motivations: props.motivations || [],
        windowDays: props.windowDays || 30,
        includeHidden: false,
        requireMinimumProfile: true,
        requireOnboardingCompleted: true,
        onboardingStartDate: '',
        onboardingEndDate: '',
        activity: '',
        withinWindowOnly: false, 
      },
    };
  }

  componentDidMount() {
    this.fetchAll();
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevState.filters) !== JSON.stringify(this.state.filters)) {
      this.fetchAll();
    }
  }

  buildParams = (extra = {}) => {
    const { filters } = this.state;
    const params = new URLSearchParams();
    params.append('start_date', filters.startDate);
    params.append('end_date', filters.endDate);
    if (filters.motivations && filters.motivations.length) {
      filters.motivations.forEach((m) => params.append('motivations[]', m));
    }
    params.append('window_days', String(filters.windowDays));
    params.append('include_hidden', String(!!filters.includeHidden));
    params.append('require_minimum_profile', String(!!filters.requireMinimumProfile));
    params.append('require_onboarding_completed', String(!!filters.requireOnboardingCompleted));
    if (filters.onboardingStartDate) params.append('onboarding_start_date', filters.onboardingStartDate);
    if (filters.onboardingEndDate) params.append('onboarding_end_date', filters.onboardingEndDate);
    if (filters.activity) params.append('activity', filters.activity);
    params.append('within_window_only', String(!!filters.withinWindowOnly));
    Object.entries(extra).forEach(([k, v]) => params.append(k, String(v)));
    return params;
  };

  fetchJSON = async (url) => {
    const res = await fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) {
      const text = await res.text();
      // eslint-disable-next-line no-console
      console.error('Request failed', url, res.status, text);
      return null;
    }
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      const text = await res.text();
      // eslint-disable-next-line no-console
      console.error('Non-JSON response', url, text);
      return null;
    }
    return res.json();
  };

  fetchAll = async () => {
    await Promise.all([this.fetchKpis(), this.fetchBreakdown(), this.fetchTable(1, this.state.table.perPage)]);
  };

  fetchKpis = async () => {
    const params = this.buildParams();
    const data = await this.fetchJSON(`/api/motivation_adoption/kpis?${params.toString()}`);
    if (!data) return;
    const completionGoal = (data.goals || []).find(g => g.goal_type === 'completion_rate' && g.window_days === this.state.filters.windowDays);
    this.setState({ kpis: data, goalStatus: { adoption: completionGoal?.status || null } });
  };

  fetchBreakdown = async () => {
    const params = this.buildParams();
    const data = await this.fetchJSON(`/api/motivation_adoption/activity_breakdown?${params.toString()}`);
    if (!data) return;
    this.setState({ breakdown: data });
  };

  fetchTable = async (page, perPage) => {
    const params = this.buildParams({ page, per_page: perPage });
    const data = await this.fetchJSON(`/api/motivation_adoption/activity_table?${params.toString()}`);
    if (!data) return;
    this.setState({ table: { rows: data.rows || [], total: data.total || 0, page: data.page || page, perPage: data.per_page || perPage } });
  };

  handleFiltersChange = (nextFilters) => {
    this.setState({ filters: { ...this.state.filters, ...nextFilters } });
  };

  handlePageChange = (page, perPage) => {
    this.fetchTable(page, perPage);
  };

  render() {
    const { kpis, breakdown, filters, table, goalStatus } = this.state;
    return (
      <Dashboard
        kpis={kpis}
        breakdown={breakdown}
        filters={filters}
        table={table}
        goalStatus={goalStatus}
        onFiltersChange={this.handleFiltersChange}
        onPageChange={this.handlePageChange}
      />
    );
  }
}

export default MotivationAdoptionContainer; 